export default __webpack_public_path__ + "static/brandon-black-041719330ac01fa7a7e017c5ae99060b.woff";